module.exports = __webpack_public_path__ + "static/img/image16.c5404195.png";